export const PROGRAM_BENEFITS_12_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_sub_title: "",
    meta_icon_bg_color: "#DADDFF",
    meta_sub_title_color: "#505050",
    meta_priority: "1",
  },

  PROGRAM_BENEFITS_12_FIELDS_CONFIG: [
    {
      fieldName: "pre_title",
      label: "Heading — highlight (e.g. Why Choose)",
      value: "Why Choose",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Leading words (same line as remainder, left-aligned in centered block)",
      required: false,
      defaultValue: "Why Choose",
    },
    {
      fieldName: "pre_title_color",
      label: "Heading highlight color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "title",
      label: "Heading — remainder (e.g. IIT Kharagpur)",
      value: "IIT Kharagpur",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Continues after highlight on the same line",
      required: true,
      defaultValue: "IIT Kharagpur",
    },
    {
      fieldName: "title_start_color",
      label: "Heading remainder color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#171719",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "subtitle",
      label: "Subheading",
      value:
        "Your education should fit your life, not the other way around.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Supporting line under the headline",
      required: false,
      defaultValue:
        "Your education should fit your life, not the other way around.",
    },
    {
      fieldName: "section_background_image",
      label: "Section background image (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload wide background",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "section_overlay_rgba",
      label: "Overlay on background (CSS rgba)",
      value: "rgba(236,236,236,0.69)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "rgba(236,236,236,0.69)",
      required: false,
      defaultValue: "rgba(236,236,236,0.69)",
    },
    {
      fieldName: "button_text",
      label: "CTA button text (leave empty to hide)",
      value: "Get Started",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Get Started",
      required: false,
      defaultValue: "Get Started",
    },
    {
      fieldName: "button_color",
      label: "CTA background color",
      value: "#DB5803",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#DB5803",
      required: false,
      defaultValue: "#DB5803",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_icon_url",
      label: "CTA status icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon shown next to button text",
      filterCategory: "images",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "CTA status icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text for the icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      filterCategory: "images",
    },
    {
      header: "Icon alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt text",
    },
    {
      header: "Icon background",
      fieldName: "meta_icon_bg_color",
      value: "#DADDFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Pastel tile behind icon",
      defaultValue: "#DADDFF",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Card title",
      required: true,
    },
    {
      header: "Description",
      fieldName: "meta_sub_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Card body",
    },
    {
      header: "Description color",
      fieldName: "meta_sub_title_color",
      value: "#505050",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#505050",
      defaultValue: "#505050",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Sort order",
      required: true,
    },
  ],
};
